import Button from "src/components/button";
import * as React from 'react';
export default {
  Button,
  React
};